const EmptyList = () => (
  <ul class='list-group'>
    <li class='list-group-item text-secondary'>
      <i>Нічо нема...</i>
    </li>
  </ul>
);

export default EmptyList;
